import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Clock, Scale } from "lucide-react";
import { LogoMark } from "./Logo";
import { SITE, COMPLIANCE_TEXT } from "../lib/siteConfig";

const COMPANY_LINKS = [
  { to: "/", label: "Home", id: "home" },
  { to: "/about", label: "About Us", id: "about" },
  { to: "/services", label: "Our Services", id: "services" },
  { to: "/how-it-works", label: "How It Works", id: "how-it-works" },
  { to: "/why-choose-us", label: "Why Choose Us", id: "why-choose-us" },
  { to: "/contact", label: "Contact Us", id: "contact" },
];

const LEGAL_LINKS = [
  { to: "/privacy-policy", label: "Privacy Policy", id: "privacy-policy" },
  { to: "/terms", label: "Terms & Conditions", id: "terms" },
  { to: "/disclaimer", label: "Disclaimer", id: "disclaimer" },
];

export default function Footer() {
  return (
    <footer className="border-t border-[rgba(212,175,55,0.15)] bg-[#0C0C10]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <LogoMark size={36} />
              <span className="leading-none">
                <span className="font-display font-bold tracking-[0.14em] gold-text block">CREDNOVA</span>
                <span className="font-mono-brand text-[9px] tracking-[0.32em] text-[#71717A] block mt-1">SERVICES PVT. LTD.</span>
              </span>
            </div>
            <p className="text-sm text-[#A1A1AA] leading-relaxed">
              Helping individuals and businesses across India connect with banks and financial institutions for suitable loan products — with transparency at every step.
            </p>
          </div>

          <div>
            <p className="caption-gold mb-5">Company</p>
            <ul className="space-y-3">
              {COMPANY_LINKS.map((l) => (
                <li key={l.id}>
                  <Link to={l.to} data-testid={`footer-link-${l.id}`} className="text-sm text-[#A1A1AA] hover:text-[#E6CA65] transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="caption-gold mb-5">Legal</p>
            <ul className="space-y-3">
              {LEGAL_LINKS.map((l) => (
                <li key={l.id}>
                  <Link to={l.to} data-testid={`footer-link-${l.id}`} className="text-sm text-[#A1A1AA] hover:text-[#E6CA65] transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="caption-gold mb-5">Contact</p>
            <ul className="space-y-3 text-sm text-[#A1A1AA]">
              <li className="flex items-start gap-3">
                <Mail size={15} className="text-[#D4AF37] mt-0.5 shrink-0" />
                <a href={`mailto:${SITE.email}`} data-testid="footer-email-link" className="hover:text-[#E6CA65] transition-colors break-all">{SITE.email}</a>
              </li>
              <li className="flex items-start gap-3">
                <Phone size={15} className="text-[#D4AF37] mt-0.5 shrink-0" />
                <a href={`tel:${SITE.phone.replace(/\s/g, "")}`} data-testid="footer-phone-link" className="hover:text-[#E6CA65] transition-colors">{SITE.phone}</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={15} className="text-[#D4AF37] mt-0.5 shrink-0" />
                <span data-testid="footer-address">{SITE.address}</span>
              </li>
              <li className="flex items-start gap-3">
                <Clock size={15} className="text-[#D4AF37] mt-0.5 shrink-0" />
                <span>{SITE.hours}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="gold-hairline my-10" />

        <div
          data-testid="footer-compliance-disclaimer"
          className="flex items-start gap-3 rounded-xl border border-[rgba(212,175,55,0.18)] bg-[#121216] p-5 mb-10"
        >
          <Scale size={18} className="text-[#D4AF37] mt-0.5 shrink-0" />
          <p className="text-xs text-[#A1A1AA] leading-relaxed">{COMPLIANCE_TEXT}</p>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[#71717A]">
          <p data-testid="footer-copyright">© {new Date().getFullYear()} {SITE.name}. All rights reserved.</p>
          <p>Loan facilitation services across India</p>
        </div>
      </div>
    </footer>
  );
}
